import { render, staticRenderFns } from "./i4pro-render-markdown.vue?vue&type=template&id=1677a3c4"
import script from "./i4pro-render-markdown.vue?vue&type=script&lang=js"
export * from "./i4pro-render-markdown.vue?vue&type=script&lang=js"
import style0 from "./i4pro-render-markdown.vue?vue&type=style&index=0&id=1677a3c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports